export default __webpack_public_path__ + "static/media/PageArchiveTable.78492f0a.less";